import React, { useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import { Country, SearchModes } from '@/domainLogic/index.ts';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation';
import { VerticalSeparator } from '@/app/common/components/Separator';
import dynamic from 'next/dynamic';
import AtolBadge from '@/app/components/search/components/Title/AtolBadge';
import { useSearchPageData } from '@/app/components/search/searchPageDataProvider.tsx';
import { useSearchDealsPageData } from '@/app/components/search/searchDealsPageProvider.tsx';
import { isSustainabilityAvailable } from '@/app/components/search/components/Banners/SustainabilityBanner/sustainabilityUtils.ts';
import { getSearchParamsClient } from '@/app/components/search/common/getSearchParams';
import { GrayButton } from './styled.ts';

const SustainabilityModal = dynamic(
  () => import('@/app/components/search/components/Modal/Modals/SustainabilityModal'),
  { ssr: false }
);

const AtolPopoverBelowNav = createGlobalStyle`
  #atol-badge-modal,
  #abta-badge-modal {
    z-index: 3;
  }
`;

export const SortBarInfoBadges = ({ isLoading }: { isLoading?: boolean }) => {
  const { searchInfoData, localization, searchParams: searchParamsServer } = usePageWrapperData();
  const { isMobile } = useCommonClient();
  const { productsData } = useSearchPageData();
  const { hasPreselectedFlight } = useSearchDealsPageData();
  const { searchMode } = searchInfoData;
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const isDP = searchMode === SearchModes.DP;
  const isTrain = searchMode === SearchModes.TH;
  const showAtolProtected = (isDP || isTrain) && localization.country === Country.GB;
  const showSustainability = isSustainabilityAvailable({
    localization,
    productsData,
    searchParams: getSearchParamsClient(searchParamsServer),
    hasPreselectedFlight,
  });

  return (
    <>
      {showSustainability && (
        <>
          <GrayButton appearance="ghost" variant="primary" onClick={() => setShowModal(true)} disabled={isLoading}>
            {t('vacation.oss.emissions.modal.title')}
          </GrayButton>
          <SustainabilityModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </>
      )}
      {showSustainability && showAtolProtected && <VerticalSeparator height={12} />}
      {showAtolProtected && (
        <>
          {!isMobile && <AtolPopoverBelowNav />}
          <AtolBadge disabled={isLoading} usePortal={false} />
        </>
      )}
    </>
  );
};
